import React, { useState, useEffect } from 'react';
import copyright from "../../assets/images/copyright-icon.png";
import dot from "../../assets/images/dot-icon.png";
import message from "../../assets/images/message-icon.png";
import call from "../../assets/images/call-icon.png";
import line from "../../assets/images/line-icon.png";
import logo from "../../assets/images/logo.png"
import "./styles.css";
import SignComponent from "../../components/Sign/SignComponent";
import ExploreButton from "../../components/Buttons/ExploreButton";
import PrivacyPolicy from "../../components/Privacy/Privacy";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CloseIcon from '../../assets/images/close-icon.png'
import { toast } from 'react-toastify';
import { url } from '../../api/axios_client';
import axios from '../../api/axios_client';
import './HomeContentEditor.css';
import LanguageSwitcher from '../../components/LanguageSwitcher';

/**
 *
 * @returns the entry page for the website
 */
export default function Home() {
  const animate = (state, id) => {
    const p = document.getElementById(id);
    const mediaQuery = window.matchMedia('(max-width: 700px)')
    if (!state) {
      if (mediaQuery.matches) {

        p.style.width = "100%";
        p.style.height = "100%";
      }
      else {

        p.style.width = "40%";

        p.style.transition = "width 2s ";
      }
      p.focus()


    }
    else {
      p.style.width = "0em";
    }

  };


  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [activeLanguage, setActiveLanguage] = useState(localStorage.getItem("language") || "ar");
  const [isDirty, setIsDirty] = useState(false);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };
  const [content, setContent] = useState({
    org: '',
    definition: {
      pt1: '',
      pt2: ''
    },
    about: '',
    explore: '',
    terms: '',
    privacy: '',
    contact: {
      email: '',
      phone: ''
    },
    copyright: ''
  });

  useEffect(() => {
    let langcheck = i18n.language === "en" || i18n.language === "ar";
    if(langcheck){
    fetchContent(i18n.language);
    }
  }, [i18n.language]);


  const fetchContent = async (lang) => {
    try {
      const response = await axios.get(`${url}/api/admin/home-content/${lang}`);
      if (response.status === 200) {
        const data = await response.data;
        console.log(data);
        setContent(data);
        setIsDirty(false);
      } else {
        toast.error('Failed to fetch content');
        // Fallback to translation if fetch fails
        loadContent(lang);
      }
    } catch (error) {
      console.error('Error fetching content:', error);
      toast.error('Error fetching content');
      // Fallback to translation if fetch fails
      loadContent(lang);
    }
  };

  const loadContent = (lang) => {
    setContent({
      org: t('Home.org', { lng: lang }),
      definition: {
        pt1: t('Home.definition.pt1', { lng: lang }),
        pt2: t('Home.definition.pt2', { lng: lang })
      },
      about: t('Home.about', { lng: lang }),
      explore: t('Home.explore', { lng: lang }),
      terms: t('Home.terms', { lng: lang }),
      privacy: t('Home.privacy', { lng: lang })
    });
  };

  return (
    <>
      <div className="home-container">
        <div className="home-header">
          <div className='home-header-title'>
            <img src={content.logo ?? logo} className='logo' alt='logo'/>
            <h3 style={{ color: "var(--secondary)", padding:"10px" }}>{content.org}</h3>
          </div>
          <div className='header-btns'>
          <LanguageSwitcher />
          <SignComponent classN="modalcontainer-home" className="account-home"/>
          </div>
        </div>

        <div className="home-content">
          <h2 className="home-header-content">
            {content.definition.pt1} -
            <span style={{ color: "var(--primary)" }}>
              {content.definition.pt2}
            </span>{" "}
          </h2>
          <p style={{ color: "var(--secondary)", marginTop: "1.5em" }}>{content.about}</p>

          <ExploreButton text={content.explore.toUpperCase()} />
        </div>

        <div className="footer">
          <div className="footer-copyright">
            <img src={copyright} style={{ width: "1em" }} />
            <span style={{ marginLeft: "4px" }} className="small-spans">
              {content.copyright}
            </span>
          </div>

          <div className="footer-rest">
            {content?.contact?.email && <div className="icons-div">
              <img src={message} className="icons-footer" />
              <span className="small-spans">{content?.contact?.email}</span>
            </div>}

            <img src={dot} className="hide-on-small" style={{ width: "0.7em" }} />

            {content?.contact?.phone && <div className="icons-div">
              <img src={call} className="icons-footer" />
              <span className="small-spans">{content?.contact?.phone}</span>
            </div>}

            <img src={line} className="hide-on-small" style={{ width: "1.4em" }} />

            <span
              className="small-spans hoverclick"
              onClick={() => {
                setTermsOpen(true);
                animate(termsOpen, "terms")
              }}
            >
              {content.terms}
            </span>

            <img src={dot} className="hide-on-small" style={{ width: "0.7em" }} />
            <span
              className="small-spans hoverclick"
              onClick={() => {
                setPrivacyOpen((prev) => !prev);
                animate(privacyOpen, "privacy")
              }}
            >
              {content.privacy}
            </span>
          </div>
        </div>
        {<div className="privacy-container" style={{ width: "0em", transition: "width 2s ease-in " }} id="privacy">
          <div style={privacyOpen ? { display: "block" } : { display: "none" }} >
            Privacy
            <img className="privacy-close" src={CloseIcon} onClick={
              () => {
                animate(privacyOpen, "privacy")
                setPrivacyOpen(false)
              }
            } />
          </div>
        </div>}

        {<div className="privacy-container" style={{ width: "0em", transition: "width 2s ease-in " }} id="terms">
          <div style={termsOpen ? { display: "block" } : { display: "none" }} >
            Terms
            <img className="privacy-close" src={CloseIcon} onClick={
              () => {
                animate(termsOpen, "terms")
                setTermsOpen(false)
              }
            } />
          </div>
        </div>}

      </div>
    </>
  );
}
